import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  FaFaceGrinHearts,
  FaFaceGrin,
  FaFaceMeh,
  FaFaceFrown,
  FaFaceAngry,
  FaRegStar,
  FaStar,
} from "react-icons/fa6";
import { AppContext } from "../context/AppContext";
import axios from "axios";
import Title from "../components/Title";
import { useDispatch, useSelector } from "react-redux";
import { getToken } from "../slice/tokenSlice";
import { FaExternalLinkAlt } from "react-icons/fa";

const AccountManager = () => {
  const dispatch = useDispatch();
  const { url, user } = useSelector((state) => state.user);
  console.log(user);
  const { notifySuccess, notifyError } = useContext(AppContext);
  const [modalVisible, setModalVisible] = useState(false);
  const [message, setMessage] = useState("");
  const [rating, setRating] = useState(1);
  const [comment, setComment] = useState("");
  const iconsArray = [
    { icon: <FaFaceAngry style={{ color: "red" }} /> },
    { icon: <FaFaceFrown style={{ color: "orange" }} /> },
    { icon: <FaFaceMeh style={{ color: "gold" }} /> },
    { icon: <FaFaceGrin style={{ color: "yellowgreen" }} /> },
    { icon: <FaFaceGrinHearts style={{ color: "green" }} /> },
  ];
  const starsArray = new Array(5).fill(null);
  const selectrating = (index) => {
    setRating(index + 1);
  };
  //
  const closeModal = () => {
    setMessage("");
    setRating(1);
    setComment("");
    setModalVisible(false);
  };
  //
  const submit = async () => {
    if (!comment) {
      setMessage("Please enter your message");
    } else {
      const token = await dispatch(getToken());
      const data = [
        {
          Lead_Name: user.id,
          Rating: rating,
          Rating_Email: "Portal",
          Review_Comment: comment,
        },
      ];
      const res = await axios.post(
        `${url}/proxy?url=https://www.zohoapis.in/crm/v2/Rating`,
        data,
        {
          headers: {
            Authorization: `Zoho-oauthtoken ${token.payload}`,
          },
        }
      );
      if (res.status === 201) {
        notifySuccess("Message sent!");
        setModalVisible(false);
        setRating(1);
        setComment("");
        setMessage("");
      } else {
        notifyError("Something went wrong");
      }
    }
  };
  useEffect(() => {
    if (message !== "") {
      setTimeout(() => {
        setMessage("");
      }, 3000);
    }
  }, [message]);
  return (
    <>
      <div>
        <Title title={"Account manager"} />
        <hr />

        <div className="mb-4">
          <p className="fw-bold">Loan Settlement Program Management</p>
          <p>
            Your dedicated account manager will be your single point of contact
            throughout your loan settlement journey. They will assist you with
            managing your settlement plan and addressing any questions or
            concerns you may have.
          </p>
        </div>
        <div className="mb-4">
          <p className="fw-bold">Legal Notices, Creditor Calls or Visits</p>
          <p>
            For any legal notices, creditor calls, or in-person visits, please
            contact your account manager first. They will escalate the matter to
            our legal or paralegal team, who will then handle it directly and
            provide the necessary support.
            <br />
            If you have general questions, we recommend checking our FAQ section
            and service brochure, where many common queries are already
            addressed
          </p>
        </div>
        <div className="mb-4">
          <p className="fw-bold">Your Account Manager</p>
          <p>
            Your assigned account manager is{" "}
            <span className="fw-bold">{user?.Account_manager?.name}</span>. For
            any assistance, you can reach out to them via call or chat — they
            are here to support you every step of the way.
          </p>

          <div className="am-btn-flex mt-2 mt-4">
            <a href="tel:02268762680" className="button">
              Call
            </a>
            <a
              href="https://wa.me/+919136087522"
              className="button"
              target="_blank"
            >
              Chat
            </a>

            <button
              className="secondary-button"
              onClick={() => setModalVisible(true)}
            >
              Rate Us
            </button>
          </div>
        </div>

        <ul className="list-unstyled">
          <li>
            <a
              href="https://settlemyloan.in/terms-and-conditions"
              target="_blank"
              className="text-primary"
            >
              Terms & Conditions
              <small>
                <FaExternalLinkAlt className="ms-2" />
              </small>
            </a>
          </li>
          <li>
            <a
              href="https://settlemyloan.in/privacy-policy"
              className="text-primary"
              target="_blank"
            >
              Privacy policy
              <small>
                <FaExternalLinkAlt className="ms-2" />
              </small>
            </a>
          </li>
          <li>
            <a
              href="https://settlemyloan.in/faqs"
              className="text-primary"
              target="_blank"
            >
              FAQ
              <small>
                <FaExternalLinkAlt className="ms-2" />
              </small>
            </a>
          </li>
          <li>
            <a
              href="https://settlemyloan.in/usp"
              className="text-primary"
              target="_blank"
            >
              SML service brochure
              <small>
                <FaExternalLinkAlt className="ms-2" />
              </small>
            </a>
          </li>
        </ul>
      </div>

      <div className={`modal-background ${modalVisible ? "active" : ""}`}>
        <div className="modal-container">
          <h2 className="mb-2 fw-bold">Please rate your account manager</h2>
          <div className="text-center my-4">
            <div className="smile-div mb-2">{iconsArray[rating - 1].icon}</div>
            <div className="star-div">
              {starsArray.map((_, index) => (
                <span key={index} onClick={() => selectrating(index)}>
                  {index < rating ? <FaStar /> : <FaRegStar />}
                </span>
              ))}
            </div>
          </div>
          <textarea
            className="input"
            placeholder="Comment"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          ></textarea>
          <p className="text-danger mb-2">{message}</p>
          <div className="d-flex align-items-center justify-content-between gap-2">
            <button className="red-button w-100" onClick={closeModal}>
              Cancel
            </button>
            <button className="button w-100" onClick={submit}>
              Submit
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountManager;
